module.exports = __webpack_public_path__ + "static/media/icon_miniarrow.3a15ba7f.svg";